// extracted by mini-css-extract-plugin
export default {"light":"TorchLight_light__j9Wbt","rotate":"TorchLight_rotate__RzqnT"};